// Contratos ganhos pela empresa (app do cliente e backoffice). Dinheiro em centavos.
import { z } from 'zod';

export const CONTRATO_STATUSES = ['vigente', 'encerrado', 'rescindido', 'suspenso'] as const;
export const CONTRATO_STATUS_NOMES: Record<(typeof CONTRATO_STATUSES)[number], string> = {
  vigente: 'Vigente',
  encerrado: 'Encerrado',
  rescindido: 'Rescindido',
  suspenso: 'Suspenso',
};

const data = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, 'Data no formato AAAA-MM-DD')
  .nullable()
  .default(null);

export const ContratoInput = z
  .object({
    numero: z.string().trim().min(1).max(60),
    ano: z.number().int().min(2000).max(2100),
    orgao: z.string().trim().min(2).max(200),
    objeto: z.string().trim().min(5).max(4000),
    valorGlobalMinor: z.number().int().nonnegative(),
    status: z.enum(CONTRATO_STATUSES).default('vigente'),
    vigenciaInicio: data,
    vigenciaFim: data,
    observacao: z.string().trim().max(2000).nullable().default(null),
    /** Edital do pipeline de onde o contrato veio (opcional). */
    fitId: z.string().uuid().nullable().default(null),
  })
  .refine((c) => !c.vigenciaInicio || !c.vigenciaFim || c.vigenciaInicio <= c.vigenciaFim, {
    message: 'Fim da vigência antes do início',
    path: ['vigenciaFim'],
  });
export type ContratoInput = z.input<typeof ContratoInput>;

export const Contrato = z.object({
  id: z.string().uuid(),
  clienteId: z.string().uuid(),
  fitId: z.string().uuid().nullable(),
  /** Objeto do edital vinculado, para mostrar na lista. */
  editalObjeto: z.string().nullable(),
  numero: z.string(),
  ano: z.number(),
  orgao: z.string(),
  objeto: z.string(),
  valorGlobalMinor: z.number(),
  status: z.enum(CONTRATO_STATUSES),
  vigenciaInicio: z.string().nullable(),
  vigenciaFim: z.string().nullable(),
  observacao: z.string().nullable(),
  criadoPor: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type Contrato = z.infer<typeof Contrato>;
export const ContratosResponse = z.object({
  itens: z.array(Contrato),
  /** Soma dos vigentes, em centavos. */
  totalVigenteMinor: z.number(),
});
